import { Component } from '@angular/core';
import { HeaderComponent } from "../../../layout/header/header.component";
import { NavbarComponent } from "../../../layout/navbar/navbar.component";
import { AlertComponentComponent } from "../../../components/alert/alert-component.component";

@Component({
  selector: 'app-no-user',
  standalone: true,
  imports: [HeaderComponent, AlertComponentComponent],
  templateUrl: './no-user.component.html',
  styleUrl: './no-user.component.css'
})
export class NoUserComponent {
  errorMessage:any="";

  ngOnInit(){
    this.errorMessage = localStorage.getItem('noUser')
  }

}
